import React from "react";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

export const UsuarioTopo = () => {
  const { t } = useTranslation();

  return (
    <div className="containerTitle">
      <Typography
        variant="h5"
        fontFamily={"Co Headline Regular"}
        gutterBottom
        align="left"
        marginLeft="15px"
      >
        {t("pages.user.titlePage")}
      </Typography>
    </div>
  );
};
